/**
 * Utility functions for USL (Unified Login) functionality
 */

import queryString from 'query-string';

// Cache for URL parameters - initialized on first call
let cachedUrlParams: queryString.ParsedQuery<string | boolean> | null = null;

/**
 * Gets URL parameters from window.location.search
 * Parameters are cached on first call to ensure consistency throughout the application lifecycle.
 * This protects against URL changes mid-flow (e.g., from navigation during async operations).
 *
 * @param forceRefresh - If true, re-reads URL params even if cached (useful for testing)
 * @returns Parsed URL parameters with boolean conversion enabled
 */
export const getUrlParams = (
  forceRefresh = false,
): queryString.ParsedQuery<string | boolean> => {
  // Return cached params if available (unless force refresh requested)
  if (cachedUrlParams !== null && !forceRefresh) {
    return cachedUrlParams;
  }

  // First call or force refresh - read and cache params
  cachedUrlParams = queryString.parse(window.location.search, {
    parseBooleans: true,
  });

  return cachedUrlParams;
};

/**
 * Clears the cached URL parameters
 * Useful for testing or when you need to re-read params after navigation
 */
export const clearUrlParamsCache = (): void => {
  cachedUrlParams = null;
};
